module.exports = __webpack_public_path__ + "static/img/12.82370e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/zh/12.png
// module id = 3wZJ
// module chunks = 0